export const NAME = 'locales';
export const FORM_NAME = 'locales';
export const REMOVE_CONFIRM_TITLE = 'Delete Locale';
export const REMOVE_CONFIRM_MESSAGE =
  'Are you sure you want to remove {locale}? Doing so will remove all localizated content.';
export const REMOVE_CONFIRM_OK = REMOVE_CONFIRM_TITLE;
export const SET_DEFAULT_CONFIRM_TITLE = 'Change Default Locale';
export const SET_DEFAULT_CONFIRM_MESSAGE = `
***WARNING!!! THIS ACTION CAN BE RISKY!!!***

There are 2 scenarios when changing a project's locale is appropriate.

1. At the start of a project to establish the default locale for which future content will be entered into the project.
2. To correct a situation where content in a single locale, that is not, {defaultLocale}, was created and the default locale is being changed to appropriately match the existing content.

Changing your default locale will relabel the default locale from {defaultLocale} to {locale}.

Existing content in {defaultLocale} will appear in {locale}. However, existing {locale} translations WILL be preserved. So, when a {locale} translation is preserved the original {defaultLocale} content will be lost. All content in the current default locale, {defaultLocale}, will be cleared.

This action is **IRREVERSIBLE** and should only be taken with a full understanding of how this change will impact the content of this project.

**TYPE THE NEW DEFAULT LOCALE CODE {locale} TO PROCEED.**`;
export const SET_DEFAULT_CONFIRM_OK = 'I Understand. Change Default Locale.';

export const SET_SINGLE_LOCALE_CONFIRM_MESSAGE =
  'Are you sure you want to change your locale from {defaultLocale} to {locale}?';
